import { Component, Input } from '@angular/core';
import { ProjectModel } from '../../../../../hub_schema/hubTypes';

@Component({
    selector: 'app-linked-workday-finance-projects-panel',
    templateUrl: './linked-workday-finance-projects-panel.component.html',
    styleUrl: './linked-workday-finance-projects-panel.component.scss',
    standalone: false
})
export class LinkedWorkdayFinanceProjectsPanelComponent {
    @Input()
    public project: ProjectModel;
}
